import * as React from 'react';
import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box,
  Stack,
  Typography,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Paper,
  Container,
  Divider,
  Grid
} from '@mui/material';

export default function MainMap(props) {
  const [address, setAddress] = useState('');
  const [selectedServices, setSelectedServices] = useState([]);
  const [notes, setNotes] = useState('');

  const handleCheckboxToggle = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service) ? prev.filter((s) => s !== service) : [...prev, service]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const details = {
      address,
      services: selectedServices,
    };

    await fetch('/api/send-renovation-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(details),
    });

    setAddress('');
    setSelectedServices([]);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, mx: 'auto' }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600, mt: 2 }}>
        Renovations
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="md">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                width: '100%',
                maxWidth: 700, // Adjust as needed for visual balance
              }}
            >
              <Typography component="h2" variant="h4" gutterBottom align="center">
                Receive a quote for all the renovations you need.
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body1" paragraph>
                Simply provide the address, select the renovations you're interested in having completed,
                and hit submit. A Rocket Offer agent will contact you shortly with quote information.
              </Typography>

              <form onSubmit={handleSubmit}>
                <TextField
                  label="Home Address"
                  fullWidth
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  sx={{ mb: 2 }}
                />

                <FormGroup>
                  <Grid container spacing={2} justifyContent="center">
                    {[
                      'Kitchen Remodel',
                      'Bathroom Upgrade',
                      'Roof Repair or Replacement',
                      'Exterior Painting or Siding Replacement',
                      'Interior Painting',
                      'Flooring Upgrades',
                      'Window Replacement',
                      'Door Replacement',
                      'Basement Finishing or Remodeling',
                      'Deck or Patio Installation',
                      'Attic Insulation',
                      'Garage Door Replacement',
                      'HVAC Upgrade',
                      'Landscaping and Yard Improvements',
                      'Fence Repair or Installation',
                      'Driveway Resurfacing or Replacement',
                      'Laundry Room Remodel',
                      'Energy-Efficient Lighting Upgrades',
                      'Waterproofing (Basement/Crawlspace)',
                      'Smart Home Upgrades (Security Systems, Thermostats, Locks, and more)'
                    ].map((type) => (
                      <Grid item xs={12} sm={6} key={type}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedServices.includes(type)}
                              onChange={() => handleCheckboxToggle(type)}
                            />
                          }
                          label={type}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </FormGroup>

                <TextField
                  label="Additional Notes"
                  multiline
                  rows={6}
                  fullWidth
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  sx={{ mt: 3 }}
                />

                <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 3 }}>
                  <FormControlLabel
                    control={<Checkbox id="ownershipCheck" required />}
                    label="I am the homeowner or representing real estate agent."
                  />
                  <Button type="submit" variant="outlined">
                    Submit
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Box>

        </Container>
      </Box>
    </Box>
  );
}
